module.exports = __webpack_public_path__ + "static/media/home-lg-alt.bf241ac1.svg";